import { motion } from "framer-motion";
import { Gamepad2, MonitorSmartphone, ArrowUpLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { LogoMark } from "@/components/Nav";

const lineReveal = {
    hidden: { y: "115%" },
    show: (i) => ({
        y: "0%",
        transition: { duration: 1.1, ease: [0.16, 1, 0.3, 1], delay: 0.25 + i * 0.15 },
    }),
};

const fadeUp = {
    hidden: { opacity: 0, y: 24 },
    show: (i) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 1, ease: [0.16, 1, 0.3, 1], delay: 0.5 + i * 0.15 },
    }),
};

export default function Games() {
    return (
        <main data-testid="games-page" className="relative min-h-[100svh] overflow-hidden">
            <div className="absolute inset-0 scanlines" aria-hidden="true" />
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(255,51,51,0.07),transparent_55%)]" aria-hidden="true" />

            <div className="relative z-10 flex min-h-[100svh] flex-col items-center justify-center px-5 text-center">
                <motion.div
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
                    className="mb-8 flex h-16 w-16 items-center justify-center rounded-full border border-[#FF3333]/40 bg-[#FF3333]/10"
                >
                    <Gamepad2 size={26} className="text-[#FF3333]" />
                </motion.div>

                <motion.p
                    custom={0}
                    variants={fadeUp}
                    initial="hidden"
                    animate="show"
                    className="font-mono-x text-[10px] sm:text-xs tracking-[0.4em] text-neutral-400 mb-6"
                >
                    EXODUSFX GAMES - GAME DEVELOPMENT
                </motion.p>

                <h1
                    data-testid="games-coming-soon-title"
                    className="font-display font-extrabold uppercase leading-[0.85] tracking-[-0.03em] select-none"
                >
                    <span className="block overflow-hidden pb-1">
                        <motion.span
                            custom={0}
                            variants={lineReveal}
                            initial="hidden"
                            animate="show"
                            data-text="COMING"
                            className="glitch block text-[13vw] sm:text-[9vw] text-[#F5F5F7]"
                        >
                            COMING
                        </motion.span>
                    </span>
                    <span className="block overflow-hidden pb-2">
                        <motion.span
                            custom={1}
                            variants={lineReveal}
                            initial="hidden"
                            animate="show"
                            data-text="SOON"
                            className="glitch text-outline block text-[13vw] sm:text-[9vw]"
                        >
                            SOON
                        </motion.span>
                    </span>
                </h1>

                <motion.p
                    custom={1}
                    variants={fadeUp}
                    initial="hidden"
                    animate="show"
                    className="mt-8 max-w-md text-sm sm:text-base leading-relaxed text-neutral-400"
                >
                    Stay tuned for upcoming game development for iOS and Android - crafted with the
                    same obsession we bring to the big screen.
                </motion.p>

                <motion.div
                    custom={2}
                    variants={fadeUp}
                    initial="hidden"
                    animate="show"
                    className="mt-10 flex flex-wrap items-center justify-center gap-4"
                >
                    <span className="flex items-center gap-2 border border-white/15 px-5 py-3 font-mono-x text-[10px] tracking-[0.3em] text-neutral-300">
                        <MonitorSmartphone size={13} className="text-[#FF3333]" /> iOS
                    </span>
                    <span className="flex items-center gap-2 border border-white/15 px-5 py-3 font-mono-x text-[10px] tracking-[0.3em] text-neutral-300">
                        <MonitorSmartphone size={13} className="text-[#FF3333]" /> ANDROID
                    </span>
                </motion.div>

                <motion.div custom={3} variants={fadeUp} initial="hidden" animate="show">
                    <Link
                        to="/"
                        data-testid="games-back-home-button"
                        className="group mt-14 inline-flex items-center gap-3 border border-white/20 px-8 py-4 font-mono-x text-[11px] tracking-[0.35em] transition-all duration-500 hover:border-[#FF3333] hover:bg-[#FF3333] hover:shadow-[0_0_30px_rgba(255,51,51,0.35)]"
                    >
                        <ArrowUpLeft size={14} className="transition-transform duration-500 group-hover:-translate-x-1 group-hover:translate-y-1" />
                        BACK TO STUDIO
                    </Link>
                </motion.div>
            </div>

            <footer className="absolute bottom-0 inset-x-0 z-10 flex items-center justify-center gap-3 pb-8">
                <LogoMark size={16} />
                <span className="font-mono-x text-[9px] tracking-[0.35em] text-neutral-600">
                    EXODUSFX GAMES - A DIVISION OF EXODUS FX
                </span>
            </footer>
        </main>
    );
}
